module.exports = __webpack_public_path__ + "static/media/andersonpaak-malibu.c63cdd70.jpg";